import SimulatorSelectionMX from "../components/simulatorSelectionMX/simulatorSelectionMX";
import { selectionCOLConfig } from "../components/simulatorSelectionMX/configs/selectionCOL.config";

export default function SimulatorSelectionCOLPage() {
  return (
    <div className="simulador-page">
      <SimulatorSelectionMX config={selectionCOLConfig} />
    </div>
  );
}
